import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Notification from './Notification';
import request from 'superagent';

export default class ComponentWrapper extends Component {
  notify = (status, text, autoClose) => {
    // Generate a unique toast for every notification
    toast[status](<Notification text={text} status={status} />, {
      containerId: 'generalContainer',
      draggable: false,
      pauseOnHover: true,
      closeOnClick: false,
      draggablePercent: 0,
      position: 'bottom-right',
      hideProgressBar: !autoClose,
      autoClose: autoClose ? autoClose * 1000 : false,
    });
  };

  then = (params) => {
    const { response, cb, notifyText, disableNotify } = params;
    if (response.data !== '') {
      const res = response.data;
      let status;

      if (res) {
        if (!disableNotify) {
          if (res._message) {
            res._message.forEach((msg) => {
              console.log('status:', status, '---', 'msg:', msg);
              status =
                msg._status === 'ok'
                  ? 'success'
                  : msg._status === 'info'
                  ? 'info'
                  : 'error';
              this.notify(status, msg.mes, msg.duration);
            });
          } else if (notifyText || res._mes) {
            status =
              res._status === 'ok'
                ? 'success'
                : res._status === 'info'
                ? 'info'
                : 'error';
            console.log('status:', status, '---', 'msg:', notifyText, res._mes);
            this.notify(status, notifyText || res._mes);
          } else if (res._rurl) {
            document.location.href = `${res._rurl}`;
          }
        }
      } else console.log('!!! not shown error:', res)

      if (cb) cb(res);
    } else {
      if (cb) cb();
    }
  };

  catch = (err, errorCb, url, disableNotify) => {
    console.log(err);

    if (errorCb) errorCb();

    if (err && typeof err === 'string' && err.includes('Request has been terminated')) {
      console.warn(`Request to ${url} was suspended due to tab inactivity. `, 'err: ', err);
      return;
    } if (!err) {
      console.log(`Request response from ${url} is empty`);
      return;
    }
  
    if (disableNotify === undefined || disableNotify === false) {
      this.notify('error', `Cannot get ${url}`);
    }
  };

  get = (params) => {
    const { url, cb, notifyText, errorCb, disableNotify } = params;

    const Mw_Zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const Mw_Offset = -new Date().getTimezoneOffset() / 60;

    request.get(url)
      .withCredentials()
      .set('Mw-Zone', Mw_Zone)
      .set('Mw-Offset', Mw_Offset.toString())
      .then((response) => {
        this.then({
          cb,
          response: { data: response.body },
          notifyText,
          disableNotify,
        });
      })
      .catch((err) => {
        this.catch(err, errorCb, url, disableNotify);
      });
  };

  post = (params) => {
    const { url, cb, notifyText, errorCb, disableNotify } = params;

    const Mw_Zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const Mw_Offset = -new Date().getTimezoneOffset() / 60;

    request.post(url)
      .withCredentials()
      .set('Mw-Zone', Mw_Zone)
      .set('Mw-Offset', Mw_Offset.toString())
      .then((response) => {
        this.then({
          cb,
          response: { data: response.body },
          notifyText,
          disableNotify,
        });
      })
      .catch((err) => {
        this.catch(err, errorCb, url, disableNotify);
      });
  };

  postWithData = (params) => {
    const { url, data, cb, errorCb, notifyText, disableNotify, headers } = params;
  
    const Mw_Zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const Mw_Offset = -new Date().getTimezoneOffset() / 60;
  
    const req = request.post(url).withCredentials();
  
    // Set any custom headers passed via params
    if (headers) {
      Object.entries(headers).forEach(([key, value]) => {
        req.set(key, value);
      });
    }
  
    // Always attach timezone headers
    req
      .set('Mw-Zone', Mw_Zone)
      .set('Mw-Offset', Mw_Offset.toString())
  
    req
      .send(data)
      .then((response) => {
        this.then({
          cb,
          response: { data: response.body },
          notifyText,
          disableNotify,
        });
      })
      .catch((err) => {
        this.catch(err, errorCb, url, disableNotify);
      });
  };  

  render() {
    return <ToastContainer containerId="generalContainer" />;
  }
};
